// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import React from 'react';
import './CheckBox.scss';
import { mergeClasses } from 'util/commons';

interface Props {
  id: string;
  className?: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  checkedStyle?: 'grey' | 'green' | 'greenOutline';
}

export const CheckBox = ({
  id,
  checked,
  onChange,
  disabled,
  className,
  checkedStyle,
}: React.PropsWithChildren<Props>) => {
  return (
    <div
      className={mergeClasses('checkbox', {
        checkedGreen: checkedStyle === 'green',
        checkedGreenOutline: checkedStyle === 'greenOutline',
      })}
    >
      <input
        id={id}
        checked={checked}
        onChange={(e) => onChange(e)}
        type="checkbox"
        disabled={disabled}
      />
      <label
        htmlFor={id}
        className={mergeClasses(
          {
            disabledLabel: disabled,
          },
          className
        )}
      />
    </div>
  );
};
